"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrderBookData = void 0;
const react_1 = require("react");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const Interfaces_1 = require("../Interfaces");
const QuotationSocketMgr_1 = require("../QuotationSocketMgr");
function useOrderBookData(options) {
    const { base, quote, exchange = Interfaces_1.EXCHANGE_PIONEXV2, precision, tickSize, duration = 0, limit = 20, focused = true } = options;
    const [orderBookData, setOrderBookData] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        setOrderBookData(undefined);
    }, [base, quote, exchange]);
    (0, react_1.useEffect)(() => {
        if (!base || !quote || !focused) {
            return;
        }
        if (limit !== undefined && limit <= 0) {
            return;
        }
        const params = {
            market: exchange,
            base: base,
            quote: quote,
            limit: limit,
        };
        if (tickSize !== undefined) {
            params.precision = tickSize;
        }
        else if (precision !== undefined) {
            params.precision = new trade_utils_lib_1.SafeDecimal(1).div(Math.pow(10, precision)).toFixed(precision);
        }
        const subscription = (0, QuotationSocketMgr_1.getGlobalQuotationSocketMgr)()
            .getOrderBookV2WebSocket()
            .getOrderBookObservable(params)
            .pipe((0, operators_1.throttleTime)(duration))
            .subscribe({
            next: (data) => {
                setOrderBookData(data);
            },
            error: () => { },
        });
        return () => subscription.unsubscribe();
    }, [base, duration, exchange, focused, limit, precision, tickSize, quote]);
    return orderBookData;
}
exports.useOrderBookData = useOrderBookData;
